import React, { useEffect, useState, useCallback } from "react";
import { useCompany } from "../../context/CompanyContext";
import { getTaxPeriods, runTaxAction } from "../../Services/taxService";
import "./tax.css";

export default function TaxPeriods() {
  const { companyId } = useCompany();
  const [rows, setRows] = useState([]);
  const [year, setYear] = useState(new Date().getFullYear());
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const load = useCallback(async () => {
    if (!companyId) return;

    setMsg("");

    try {
      const data = await getTaxPeriods(companyId);
      setRows(data || []);
    } catch (err) {
      setMsg(err.message || "Failed to load tax periods");
    }
  }, [companyId]);

  useEffect(() => {
    load();
  }, [load]);

  async function handleGenerate() {
    if (!companyId) return;
    setBusy(true);
    setMsg("");
    try {
      await runTaxAction({
        action: "generate_periods",
        companyId,
        year: Number(year),
      });
      setMsg(`Tax periods generated for ${year}`);
      await load();
    } catch (err) {
      setMsg(err.message || "Failed to generate periods");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="tax-page">
      <div className="tax-page-header">
        <div>
          <h1>Tax Periods</h1>
          <p>Generate and review VAT, WHT, CIT and Development Levy periods.</p>
        </div>

        <div className="tax-actions">
          <input
            className="tax-year-input"
            type="number"
            value={year}
            onChange={(e) => setYear(e.target.value)}
          />
          <button
            className="tax-btn primary"
            onClick={handleGenerate}
            disabled={busy}
          >
            {busy ? "Generating..." : "Generate Periods"}
          </button>
        </div>
      </div>

      {msg ? <div className="tax-alert">{msg}</div> : null}

      <div className="tax-panel">
        {rows.length === 0 ? (
          <div className="tax-empty">No tax periods found.</div>
        ) : (
          <div className="tax-table-wrap">
            <table className="tax-table">
              <thead>
                <tr>
                  <th>Tax Type</th>
                  <th>Start</th>
                  <th>End</th>
                  <th>Due Date</th>
                  <th>Payment Due</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row.id}>
                    <td>{row.tax_type_code}</td>
                    <td>{row.period_start}</td>
                    <td>{row.period_end}</td>
                    <td>{row.due_date || "-"}</td>
                    <td>{row.payment_due_date || "-"}</td>
                    <td>{row.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
